import { Alert, Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { Flex } from './flex'
import { CheckboxField, DateField, InputField, MultipleSelectField } from './input'
import { TranscriptionForm } from './type'

type TranscriptionModalProps = {
    model: string
    toModel: string
    transcriptionForm: Form<TranscriptionForm>
    onClickOk: () => void
    show: boolean
    onHide: () => void
    showResearchName?: boolean
    hideDate?: boolean
    hideStaff?: boolean
    hideNote?: boolean
    // showUseUp?: boolean
}

export const TranscriptionModal = (props: TranscriptionModalProps): JSX.Element => {
    const errorForm = useForm<{ errors?: string[]; optionalError?: string; isSuccess?: boolean }>({ errors: [] })

    useEffectSkipFirst(() => {
        props.transcriptionForm.update((f) => {
            f.errorNote = [...(errorForm.object.errors ?? []), errorForm.object.optionalError].filter((s) => !!s && s !== 'その他').join('、')
        })
    }, [errorForm.object])

    const enabled = (): boolean => {
        const form = props.transcriptionForm.object
        const isCheckedError = (errorForm.object.errors && errorForm.object.errors.length > 0) || errorForm.object.optionalError || errorForm.object.isSuccess
        if (!props.hideDate && form.date && isCheckedError) {
            return true
        } else if (props.hideDate && isCheckedError) {
            return true
        } else {
            return false
        }
    }

    const handleClickOk = () => {
        // if (props.showUseUp && !props.transcriptionForm.object.notHasEmptySample) {
        //     const notHasEmpty = props.transcriptionForm.object.items.every((item) => !item.useUp)
        //     if (notHasEmpty) {
        //         globalState.setNotificationMessage({ body: '使用済みとなった検体をチェックしてください', colorType: 'danger' })
        //         return
        //     }
        // }
        props.onClickOk()
    }

    useEffectSkipFirst(() => {
        if (props.toModel === 'Extraction' && props.transcriptionForm.object.items.length === 0) {
            props.transcriptionForm.update((f) => (f.standardCount = 1))
        } else {
            props.transcriptionForm.update((f) => delete f.standardCount)
        }
    }, [props.show])

    return (
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>確認</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {props.toModel === 'Extraction' && props.transcriptionForm.object.items.length !== 0 && (
                    <Alert variant="danger">標準尿も自動で転記されます。標準尿の抽出・精製を忘れないでください</Alert>
                )}
                {props.transcriptionForm.object.items.length !== 0 && (
                    <>
                        選択中の{props.model}({props.transcriptionForm.object.items.length}件)を
                        <span style={{ fontWeight: 'bold' }}>「{props.toModel}」</span>
                        に転記します。
                        <br />
                        同じものを複数転記する場合は数を変更してください
                        <div style={{ padding: 15, maxHeight: 400, overflowY: 'scroll' }}>
                            {props.transcriptionForm.object.items.map((item, index) => {
                                return (
                                    <Flex key={`${item.id}-${index}`} alignItems="center" style={{ marginBottom: 10 }}>
                                        <div style={{ flexGrow: 1, marginRight: 30 }}>{item.id}</div>
                                        {/* <>
                                    <div>x</div>
                                    <div style={{ width: 70 }}>
                                        <InputField
                                            type="number"
                                            form={props.transcriptionForm}
                                            attr={['items', index, 'count']}
                                            min={1}
                                            style={{ margin: '2px 0' }}
                                        ></InputField>
                                    </div>
                                </> */}
                                    </Flex>
                                )
                            })}
                        </div>
                    </>
                )}

                {props.toModel === 'Extraction' && props.transcriptionForm.object.items.length === 0 && (
                    <InputField
                        form={props.transcriptionForm}
                        attr="standardCount"
                        label="転記する標準尿の数"
                        type="number"
                        min={1}
                        placeholder="デフォルト1"
                        required
                    />
                )}
                {/* {!props.transcriptionForm.object.mergeItem && (
                    <Button
                        onClick={() => {
                            props.transcriptionForm.updateObject('items', shuffleArray(props.transcriptionForm.object.items))
                        }}
                    >
                        ランダマイズ
                    </Button>
                )} */}
                {/* <CheckboxField form={props.transcriptionForm} attr="isRandomize" checkboxLabel={'ランダマイズして転記する'} /> */}
                <Flex style={{ marginTop: 15 }}>
                    {/* {!props.hideStaff && (
                        <SelectField
                            required
                            form={props.transcriptionForm}
                            attr="staffId"
                            selectItems={masterData.staffs.map((s) => {
                                return { label: s.nameJp, value: s.id! }
                            })}
                            includeBlank
                            label="スタッフ"
                        />
                    )} */}
                    {!props.hideDate && <DateField form={props.transcriptionForm} attr="date" label="日時" required />}
                </Flex>
                {(props.toModel === 'Extraction' || props.toModel === 'cDNA') && (
                    <div>
                        <MultipleSelectField
                            id="error-select"
                            form={errorForm}
                            attr="errors"
                            hideSearch
                            hideSelectAll
                            horizontal
                            label="作業時のエラー、不具合等"
                            selectItems={(props.toModel === 'Extraction'
                                ? [
                                      '試薬の入れ間違い/入れ忘れ',
                                      '蓋に触れてしまった',
                                      '工程を飛ばす',
                                      '異物混入',
                                      'チップのはまりが悪かった',
                                      '久しぶりの作業で手が震えた',
                                      'その他',
                                  ]
                                : [
                                      '試薬の入れ間違い/入れ忘れ',
                                      '蓋に触れてしまった',
                                      '試薬の融解不足',
                                      '試薬はき出しきれなかった',
                                      '久しぶりの作業で手が震えた',
                                      'その他',
                                  ]
                            ).map((s) => {
                                return { label: s, value: s }
                            })}
                        />
                        {errorForm.object.errors?.includes('その他') && (
                            <InputField form={errorForm} attr="optionalError" placeholder="その他の理由を記載してください" />
                        )}

                        {(!errorForm.object.errors || errorForm.object.errors.length === 0) && !errorForm.object.optionalError && (
                            <Alert variant="success" style={{ marginTop: 10 }}>
                                <CheckboxField form={errorForm} attr="isSuccess" checkboxLabel="エラー、不具合はなかった" />
                            </Alert>
                        )}
                    </div>
                )}
                {!props.hideNote && <InputField form={props.transcriptionForm} attr="note" label="Note" as="textarea" />}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleClickOk} disabled={!enabled()}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
